module.exports = __webpack_public_path__ + "img/sub_support_6.1cc7c541.png";